<nav #tabsNav class="product-nav-tabs" aria-label="Product sections">
  <ul class="product-nav-tabs__list">
    @for (tab of tabsData(); track trackByFn($index, tab)) {
      @if (!tab.hiddenTab) {
        <li class="product-nav-tabs__item">
          <button
            type="button"
            class="product-nav-tabs__link"
            [ngClass]="{ 'product-nav-tabs__link--active': isTabActive(tab) }"
            (click)="onTabClick(tab)">
            @if (tab.iconName) {
              <i
                class="iconsax product-nav-tabs__icon"
                [attr.icon-name]="tab.iconName"
                aria-hidden="true"></i>
            }
            <span class="product-nav-tabs__label">
              @if (
                tab.tabTitle === 'comments' &&
                tab.tabDataCount != null &&
                +tab.tabDataCount > 0
              ) {
                {{
                  'products.commentsCount'
                    | translate: { count: tab.tabDataCount }
                }}
              } @else {
                {{ getTabLabel(tab) | translate }}
              }
            </span>
          </button>
        </li>
      }
    }
  </ul>
</nav>
